document.addEventListener('DOMContentLoaded', () => {
  const sidebar = document.querySelector('.sidebar');
  if (sidebar) {
    const categoriesList = document.querySelector('.sidebar__categories');
    if (categoriesList && window.matchMedia('(min-width: 992px)').matches) {
      categoriesList.classList.add('sidebar__item_active');
    }

    const filterItems = sidebar.querySelectorAll('.ocf-filter-header');
    filterItems.forEach((item, i) => {
      if (i === 0) item.classList.add('ocf-filter-header_active');
      item.addEventListener('click', () => {
        item.classList.toggle('ocf-filter-header_active');
      });
    });
  }
});
